import PubSub from 'pubsub-js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const homeHeader = {
  init() {
    this.$header = document.querySelector('section.home_header');

    if (this.$header !== null) {
      console.log('Home header init!');

      this.destroyBinded = this.destroy.bind(this);
      this.resizeHandlerBinded = this.resizeHandler.bind(this);
      this.clickHandlerBinded = this.clickHandler.bind(this);
      this.setUpListeners();

      if (document.documentElement.classList.contains('splash_enabled')) {
        this.startUp();
      } else {
        // do not animate the splash screen if we come from another page
        this.skipSplash();
      }
    }
  },

  setUpListeners() {
    PubSub.subscribe('page.transitionMiddle', this.destroyBinded);
    window.addEventListener('resize', this.resizeHandlerBinded);

    'click wheel touchstart'.split(' ').forEach((evName) => {
      this.$header
        .addEventListener(evName, this.clickHandlerBinded);
    });
  },

  clickHandler(ev) {
    ev.preventDefault();

    this.animatePageIn();

    // remove the listener
    'click wheel touchstart'.split(' ').forEach((evName) => {
      this.$header
        .removeEventListener(evName, this.clickHandlerBinded);
    });
  },

  resizeHandler() {
    this.destroyTrigers();
    // this.setUpScrollingText();
  },

  startUp() {
    const tl = gsap.timeline({});

    tl.to(this.$header.querySelector('.bg_wrapper'), {
      opacity: 1
    });

    tl.to(this.$header.querySelector('.logo'), {
      opacity: 1,
      duration: 2
    });

    setTimeout(() => {
      document.documentElement.scrollTop = 0;
    }, 10);
  },

  skipSplash() {
    const $whiteLogo = this.$header.querySelector('.logo');
    const $curtains = this.$header.querySelectorAll('.curtain');
    const $introContainer = this.$header.querySelector('.intro_wrapper');
    const $introText = $introContainer.querySelector('.intro_text');

    gsap.set($whiteLogo, {
      opacity: 0
    });

    gsap.set($curtains, {
      width: window.innerWidth > 767 ? '1.2rem' : '0.4rem'
    });

    gsap.set($introContainer, {
      height: window.innerWidth > 767 ? '4.58rem' : '4.1rem'
    });

    gsap.set(document.getElementById('main_header'), {
      opacity: 1
    });

    gsap.to($introText, {
      duration: 2,
      opacity: 1
    });

    gsap.set(this.$header.querySelector('.bg_wrapper'), {
      opacity: 1
    });

    document.documentElement.classList.remove('splash_enabled');
  },

  animatePageIn() {
    const $whiteLogo = this.$header.querySelector('.logo');
    const $curtains = this.$header.querySelectorAll('.curtain');
    const $introContainer = this.$header.querySelector('.intro_wrapper');
    const $introText = $introContainer.querySelector('.intro_text');
    const tl = gsap.timeline({});
    const curtainDur = 1.2;
    const curtainEase = 'expo.out';
    const showDur = 1.2;
    const showEase = 'power1.inOut';

    tl.to($whiteLogo, {
      opacity: 0,
      duration: curtainDur,
      ease: curtainEase
    });

    tl.to($curtains, {
      width: window.innerWidth > 767 ? '1.2rem' : '0.4rem',
      duration: curtainDur,
      ease: curtainEase
    }, 0);

    tl.to($introContainer, {
      height: window.innerWidth > 767 ? '4.58rem' : '4.1rem',
      duration: curtainDur,
      ease: curtainEase,
      onComplete() {
        document.documentElement.classList.remove('splash_enabled');
      }
    }, 0);

    tl.to(document.getElementById('main_header'), {
      opacity: 1,
      duration: showDur,
      ease: showEase
    }, curtainDur * 0.4);

    tl.to($introText, {
      opacity: 1,
      duration: showDur,
      ease: showEase
    }, curtainDur * 0.6);
  },

  destroyTrigers() {
    const triggers = ScrollTrigger.getAll();

    triggers.forEach(trigger => {
      if (trigger.vars.id === 'scrolling_type') {
        trigger.kill();
        console.log('Destroying homeHeader ScrollTrigger triggers');
      }
    });

    ScrollTrigger.refresh();
  },

  destroy() {
    console.log('Destroy: header module');

    PubSub.unsubscribe('page.transitionMiddle', this.destroyBinded);
    window.removeEventListener('resize', this.resizeHandlerBinded);
  }
};

PubSub.subscribe('page.inDOM', homeHeader.init.bind(homeHeader));

export default homeHeader;
